import { ApiClients } from '@roolz/api/clients'
import {
  AcceptInvitationByHashResponse,
  AcceptInvitationRequest,
  CheckEmailInCompanyRequest,
  Company,
  CreateCompanyRequest,
  DeleteCompanyRequest,
  GetAllPublicCompanies, GetAllPublicCompaniesResponse,
  SendCompanyInvitationRequest,
  UpdateCompanyRequest
} from '@roolz/types/api/companies'
import {
  CompanyInvitationsResponse,
  CompanyMembersResponse,
  GetCompanyMembersRequest,
  Statuses
} from '@roolz/types/api/companyMembers'
import { CompanyInvitation, Profile } from '@roolz/types/api/profiles'
import { AxiosInstance } from 'axios'
import qs from 'qs'

export class CompaniesApi {
  identity: AxiosInstance
  identity2: AxiosInstance

  constructor(clients: ApiClients) {
    this.identity = clients.identity
    this.identity2 = clients.identity2
  }

  sendInvitation(companyId: Company['id'], body: SendCompanyInvitationRequest) {
    return this.identity2.post(`/v1/private/companies/id/${companyId}/invitation`, body)
  }

  cancelInvitation(companyId: Company['id'], inviteId: string) {
    return this.identity2.post(`/v1/private/companies/id/${companyId}/invitation/id/${inviteId}/cancel`)
  }

  resendInvitation(companyId: Company['id'], inviteId: string) {
    return this.identity2.post(`/v1/private/companies/id/${companyId}/invitation/id/${inviteId}/resend`)
  }

  deleteMember(companyId: Company['id'], profileId: Profile['id']) {
    return this.identity2.delete(`/v1/private/companies/id/${companyId}/member/${profileId}`)
  }

  acceptInvitationByHash(hash: string, device: any) {
    return this.identity2.post<AcceptInvitationByHashResponse>(`/v1/public/companies/invitation/magic_hash/accept`, {
      magic_hash: hash,
      device
    })
  }

  declineInvitationByHash(hash: string, device: any) {
    return this.identity2.post<CompanyInvitation>(`/v1/public/companies/invitation/magic_hash/decline`, {
      magic_hash: hash,
      device
    })
  }

  getCompanyMembers(companyId: Company['id'], {
    offset = 0,
    limit = 20,
    ...rest
  }: GetCompanyMembersRequest) {
    return this.identity2.get<CompanyMembersResponse>(`/v1/private/companies/id/${companyId}/members`, {
      params: {
        offset,
        limit,
        ...rest
      }
    })
  }

  getCompanyInvitations(companyId: Company['id'], params) {
    return this.identity2.get<CompanyInvitationsResponse>(`/v1/private/companies/id/${companyId}/invitations`, {
      params
    })
  }

  getInvitationsStatuses(companyId: Company['id']) {
    return this.identity2.get<Statuses>(`/v1/private/companies/id/${companyId}/invitations/by_status`)
  }

  checkEmailInCompany(companyId: string, params: CheckEmailInCompanyRequest) {
    return this.identity2.get(`/v1/private/companies/id/${companyId}/check_email`, { params })
  }

  acceptInvitation(companyId: Company['id'], inviteId: string, body: AcceptInvitationRequest) {
    return this.identity2.post(`/v1/private/companies/id/${companyId}/invitation/id/${inviteId}/accept`, body)
  }

  declineInvitation(companyId: Company['id'], inviteId: string) {
    return this.identity2.post<Company>(`/v1/private/companies/id/${companyId}/invitation/id/${inviteId}/decline`)
  }

  getAllCompanies({ params, body }: GetAllPublicCompanies) {
    return this.identity2.post<GetAllPublicCompaniesResponse>('/v1/private/companies/list',
      body,
      {
        paramsSerializer: (params: any) => qs.stringify(params, { encode: false, arrayFormat: 'comma' }),
        params
      })
  }

  getAllCompaniesPublic({ params, body }: GetAllPublicCompanies) {
    return this.identity2.post<GetAllPublicCompaniesResponse>('/v1/public/companies/list',
      body,
      {
        paramsSerializer: (params: any) => qs.stringify(params, { encode: false, arrayFormat: 'comma' }),
        params
      })
  }

  // getCompanyByIdPublic(companyId: string) {
  //   return this.identity2.get<Company>(`/v1/public/companies/id/${companyId}`)
  // }

  getCompanyByNicknamePublic(nickname: string) {
    return this.identity2.get<Company>(`/v1/public/companies/nick/${nickname}`)
  }

  getCompanyByNickname(nickname: string) {
    return this.identity2.get<Company>(`/v1/private/companies/nick/${nickname}`)
  }

  getOwnCompanies() {
    return this.identity2.get<Company[]>('/v1/private/me/companies')
  }

  getCompanyById(companyId: string) {
    return this.identity2.get<Company>(`/v1/private/companies/id/${companyId}`)
  }

  createCompany(body: CreateCompanyRequest) {
    return this.identity2.post<Company>('/v1/private/companies', body)
  }

  updateCompany(company_id: string, body: UpdateCompanyRequest) {
    return this.identity2.patch<Company>(`/v1/private/companies/id/${company_id}`, body)
  }

  deleteCompany(company_id: string, body: DeleteCompanyRequest) {
    return this.identity2.delete(`/v1/private/companies/id/${company_id}`, {
      data: { body }
    })
  }
}
